import React, {useEffect, useState} from 'react'
import {useDownloadURL, useUploadFile} from 'react-firebase-hooks/storage';
import {firebaseStorage, storageRef} from "../firebase/client-app";
import Dropzone, {useDropzone} from "react-dropzone";
import _ from "lodash";
import {getDownloadURL} from "@firebase/storage";
import {CheckCircleIcon, CloudArrowUpIcon, DocumentArrowUpIcon, XCircleIcon} from "@heroicons/react/24/solid";
import {addQuotes} from "../common/services/quote-data-service";
import {addImages, addSingleImage} from "../common/services/image-data-service";
import shortid from "shortid";
import {UPLOADED_IMAGES_PATH} from "../common/constants/image.constant";
import ShowLink from "../common/ui/show-link";
import Promise from "bluebird";
import SelectTags from "../tag/select-tags";
import {searchTags} from "../common/services/tag-data-service";
import {uploadSingleImageFileDataUrl, uploadSingleImageFileRaw} from "../common/utils/file-data-service";
import imageDetail from "./image-detail";
import {addSingleDesign} from "../design/services/design-data-service";
import {searchThemes} from "../theme/services/theme-data-service";
import SelectThemes from "../theme/components/select-themes";

const ImageUpload = () => {
    const {acceptedFiles, getRootProps, getInputProps} = useDropzone();
    const [uploadFile, uploading, snapshot, error] = useUploadFile();
    const [initialStep, setInitialStep] = useState(true);
    const [selectedFile, setSelectedFile] = useState<File>();
    const [allFiles, setAllFiles] = useState([]);
    const [uploadedFiles, setUploadedFiles] = useState({});
    const [progressFiles, setProgressFiles] = useState({});
    const [uploadCompleted, setUploadCompleted] = useState(false);
    const [uploadStarted, setUploadStarted] = useState(false);
    const [allThemes, setAllThemes] = useState([]);
    const [allTags, setAllTags] = useState([]);
    const [selectedDetail, setSelectedDetail] = useState({
        themes: {},
        themeList: [],
        tags: {},
        tagList: [],
    });

    useEffect(() => {
        getThemesList();
        getTagsList();
    }, [initialStep]);

    const getThemesList = async () => {
        const themesListResult = await searchThemes('')
        setAllThemes(themesListResult);
    }

    const getTagsList = async () => {
        const tagsListResult = await searchTags('');
        setAllTags(tagsListResult);
    }

    const uploadFiles = async () => {
        setUploadStarted(true);
        let existingAllFiles = [...allFiles];

        const existingSelectedDetail = {...selectedDetail};

        await Promise.map(existingAllFiles, async file => {
                setAllFiles(existingAllFiles);

                let imageDetail: any = {
                    name: file.name,
                    path: file.path,
                    type: file.type,
                    tags: existingSelectedDetail.tags,
                    tagList: existingSelectedDetail.tagList,
                    themes: existingSelectedDetail.themes,
                    themeList: existingSelectedDetail.themeList
                }

                imageDetail.id = await addImageDetail(imageDetail);

                const metaData = {
                    customMetadata: {
                        imageId: imageDetail.id,
                    }
                };

                const filePath = UPLOADED_IMAGES_PATH + '/' + file.newName;
                const result = await uploadSingleImageFileRaw(filePath, file, metaData);

                file.status = 'uploaded';
                setAllFiles(existingAllFiles);
            }
        ).then(result => {
            setAllFiles(existingAllFiles);
            setUploadCompleted(true);
            setUploadStarted(false);
        });
    }

    const addImageDetail = async (newImageDetail) => {
        const addedImageDetailResult: any = await addSingleImage(newImageDetail);
        return addedImageDetailResult.id;
    }

    const selectAllFiles = (files) => {
        _.forEach(files, async file => {
            const fileNameString = _.split(file.name, '.');
            fileNameString[fileNameString.length - 1] = shortid.generate() + '.' + _.last(fileNameString);
            file.newName = _.join(fileNameString, '-');
            file.status = 'progress';
        });

        setAllFiles(files);
        setUploadCompleted(false);
    }

    const removeFile = (file) => {
        let existingAllFiles = [...allFiles];
        existingAllFiles = _.filter(existingAllFiles, (existingFile) => {
            return existingFile.path !== file.path;
        });

        setAllFiles(existingAllFiles);
        setUploadStarted(false);
    }

    /*const handleTagChanges = async (event) => {
        const {name, value} = event.target;
        const existingSelectedDetail = {...selectedDetail};
        existingSelectedDetail[name] = value;

        if (name === 'tagList') {
            const tempTags = {};
            _.forEach(value, tagId => {
                tempTags[tagId] = true;
            });

            existingSelectedDetail['tags'] = tempTags;
            existingSelectedDetail['tagList'] = value;
        }

        setSelectedDetail(existingSelectedDetail);
    }*/

    const handleThemeTagChanges = async (event) => {
        const {name, value} = event.target;
        const existingSelectedDetail = {...selectedDetail};
        existingSelectedDetail[name] = value;

        if (name === 'themeList') {
            const tempThemes = {};
            _.forEach(value, themeId => {
                tempThemes[themeId] = true;
            });

            existingSelectedDetail['themes'] = tempThemes;
            existingSelectedDetail['themeList'] = value;
        }

        if (name === 'tagList') {
            const tempTags = {};
            _.forEach(value, tagId => {
                tempTags[tagId] = true;
            });

            existingSelectedDetail['tags'] = tempTags;
            existingSelectedDetail['tagList'] = value;
        }

        setSelectedDetail(existingSelectedDetail);
    }

    return (
        <>

            <div className="page-container-background">

                <div className="flex justify-between items-center pt-8 px-8">
                    <div className="flex justify-start items-center">
                        <div className="mr-4">
                            <ShowLink label="Back"
                                      url="/images"/>
                        </div>

                        <div className="text-xl">
                            Upload Images
                        </div>
                    </div>

                    <div className="flex justify-center items-center mr-1 float-right">
                        {(!uploadCompleted && !uploadStarted) && allFiles?.length > 0 &&
                            <button
                                onClick={() => {
                                    uploadFiles()
                                }}
                                className="rounded font-light border py-2 px-4 text-white bg-neutral-500 hover:border-neutral-500 hover:text-neutral-500 hover:bg-white">
                                <span className="">Upload {allFiles?.length} Files</span>
                            </button>
                        }

                        {(!uploadStarted && uploadCompleted) &&
                            <div className="text-lg font-bold text-green-600">All {allFiles?.length} Files
                                Uploaded</div>
                        }

                        {(uploadStarted && !uploadCompleted) &&
                            <div
                                className="text-lg font-bold text-yellow-600">Uploading {allFiles?.length} Files...</div>
                        }
                    </div>
                </div>

            </div>

            <div className="flex justify-center items-start px-8">

                <div className="w-full pr-8">
                    <div
                        className="flex justify-center items-center mt-4 w-full">
                        <Dropzone onDrop={selectAllFiles}>
                            {({getRootProps, getInputProps}) => (
                                <div className="w-full">
                                    <div {...getRootProps({className: 'dropzone w-full flex items-center justify-center h-44 border border-gray-400 bg-gray-50 shadow-inner rounded hover:bg-gray-400 hover:text-white'})}>
                                        <input {...getInputProps()} />
                                        Drag & drop some files here, or click to select files
                                    </div>
                                </div>
                            )}
                        </Dropzone>
                    </div>
                </div>

                <div className="w-full">
                    {allThemes?.length > 0 &&
                        <div
                            className="h-44 overflow-y-scroll border-gray-400 border bg-blue-50 my-4 rounded">
                            <SelectThemes
                                existingThemes={selectedDetail?.themeList}
                                allThemes={allThemes}
                                handleSelectThemesChanges={handleThemeTagChanges}
                                showClearSelectedThemes={false}
                                showClearSelectedThemesIcon={false}/>
                        </div>
                    }
                </div>

            </div>

            <div className="flex justify-center items-start px-8">

                {allTags?.length > 0 &&
                    <div
                        className="h-44 overflow-y-scroll border-gray-400 border bg-blue-50 my-4 rounded">
                        <SelectTags
                            existingTags={selectedDetail?.tagList}
                            allTags={allTags}
                            handleSelectTagsChanges={handleThemeTagChanges}
                            showAddTag={true}
                            showClearSelectedTags={true}
                            showClearSelectedTagsIcon={true}/>
                    </div>
                }

            </div>

            <div
                className="mx-8 mt-4 p-4 flex flex-wrap justify-center items-start overflow-y-scroll uploaded-images-container border-gray-400 border bg-blue-50 rounded">
                {allFiles?.map((file: any) => (
                    <div key={file?.newName} className="text-center bg-white shadow m-2 rounded border">
                        {file?.status === 'progress' && !uploadStarted &&
                            <button
                                onClick={() => removeFile(file)}
                                className='m-2 py-1 px-2 text-sm rounded border border-gray-500 text-gray-500 hover:border-red-500 hover:bg-red-500 hover:text-white'>
                                Remove
                            </button>
                        }

                        {(file?.status === 'progress' && (uploadStarted && !uploadCompleted)) &&
                            <div
                                className='m-2 py-1 px-2 text-sm rounded flex justify-center items-center'>
                                <div>
                                    <CloudArrowUpIcon className="h-6 w-6 text-yellow-500 mr-1"/>
                                </div>
                                In Progress...
                            </div>
                        }

                        {(file?.status === 'uploaded' || (!uploadStarted && uploadCompleted)) &&
                            <div
                                className='m-2 py-1 px-2 text-sm rounded flex justify-center items-center'>
                                <div>
                                    <CheckCircleIcon className="h-6 w-6 text-green-500 mr-1"/>
                                </div>
                                Uploaded
                            </div>
                        }

                        <img src={URL.createObjectURL(file)}
                             className="shadow bg-gray-100 hover:bg-neutral-400 rounded"
                             width={150}>
                        </img>
                    </div>
                ))}
            </div>
        </>
    )
}

export default ImageUpload
